import React from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { OrderPageStatus } from '../api';
import { useManagePasses } from './ManagePassesContext';
import { BuyPassCard } from './components/BuyPassCard';
import { EmptyState } from './components/EmptyState';
import { isPassHiddenFromCustomer } from './utils/passUtils';

export const BuyPassPage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { account, passes } = useManagePasses();

  if (!account) {
    return null;
  }

  const isRtl = i18n.dir() === 'rtl';

  const lastPurchasedOrderPageId =
    passes.length > 0
      ? [...passes].sort((a, b) => moment(b.created_at).valueOf() - moment(a.created_at).valueOf())[0].order_page_id
      : null;

  const availablePasses = (account.pass_order_pages || [])
    .filter((p) => p.status === OrderPageStatus.ACTIVE && !isPassHiddenFromCustomer(account, p.id))
    .sort((a, b) => {
      if (a.id === lastPurchasedOrderPageId) {
        return -1;
      }
      if (b.id === lastPurchasedOrderPageId) {
        return 1;
      }
      return 0;
    });

  return (
    <Grid container flexDirection="column" gap={2.5}>
      <Grid container alignItems="center" gap={1}>
        <IconButton onClick={() => navigate('/passes/dashboard')} size="small" edge="start">
          {isRtl ? <ArrowForwardIcon /> : <ArrowBackIcon />}
        </IconButton>
        <Typography variant="h5" fontWeight={600}>
          {t('manage_passes.buy.title')}
        </Typography>
      </Grid>

      {availablePasses.length > 0 ? (
        availablePasses.map((passOrderPage) => (
          <BuyPassCard
            key={passOrderPage.id}
            passOrderPage={passOrderPage}
            account={account}
            isLastPurchased={passOrderPage.id === lastPurchasedOrderPageId}
          />
        ))
      ) : (
        <EmptyState message={t('manage_passes.buy.noPassesAvailable')} />
      )}
    </Grid>
  );
};
